var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-credit-cards" },
    [
      _c(
        "b-card",
        {
          staticClass: "mb-2",
          attrs: { title: _vm.$t("user_credit_cards.title") },
        },
        [
          _c("p", { staticClass: "text-muted mb-3" }, [
            _vm._v(_vm._s(_vm.$t("user_credit_cards.intro"))),
          ]),
          _c("div", { staticClass: "flex flex-wrap gap-3 items-end mb-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "w-full sm:w-auto flex-grow select-suggestion-user",
              },
              [
                _c("select-suggestion", {
                  attrs: {
                    column: "name,email",
                    model: "User",
                    label: _vm.$t("user_credit_cards.select_user"),
                    appendClearOption: true,
                    placeholderText: _vm.$t(
                      "user_credit_cards.user_placeholder"
                    ),
                    itemTextFormat: _vm.formatUserNameEmailHtml,
                    "dropdown-options-class": "user-suggest-dropdown",
                  },
                  model: {
                    value: _vm.selectedUser,
                    callback: function ($$v) {
                      _vm.selectedUser = $$v
                    },
                    expression: "selectedUser",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "b-alert",
            { staticClass: "p-1 mb-4", attrs: { variant: "info", show: "" } },
            [
              _c("small", [
                _vm._v(
                  _vm._s(_vm.$t("user_credit_cards.register_in_marketplace"))
                ),
              ]),
            ]
          ),
          !_vm.selectedUser
            ? _c("div", { staticClass: "text-muted py-3" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("user_credit_cards.pick_user_hint")) + " "
                ),
              ])
            : _vm.loading
            ? _c("div", { staticClass: "py-4 text-center" }, [
                _vm._v(" " + _vm._s(_vm.$t("common.loading")) + " "),
              ])
            : !_vm.cards.length
            ? _c("div", { staticClass: "text-muted py-3" }, [
                _vm._v(" " + _vm._s(_vm.$t("user_credit_cards.empty")) + " "),
              ])
            : _c("div", { staticClass: "overflow-x-auto" }, [
                _c("table", { staticClass: "table b-table table-striped" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("user_credit_cards.col_id"))),
                      ]),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("user_credit_cards.col_number"))),
                      ]),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("user_credit_cards.col_brand"))),
                      ]),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("user_credit_cards.col_holder"))),
                      ]),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("user_credit_cards.col_expiry"))),
                      ]),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("user_credit_cards.col_gateway"))),
                      ]),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("user_credit_cards.col_token"))),
                      ]),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("user_credit_cards.col_default"))),
                      ]),
                      _c("th", { attrs: { width: "120" } }),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.cards, function (c) {
                      return _c("tr", { key: c.id }, [
                        _c("td", [_vm._v(_vm._s(c.id))]),
                        _c("td", [_vm._v(_vm._s(c.masked_number))]),
                        _c("td", [_vm._v(_vm._s(c.brand_label || c.brand))]),
                        _c("td", [_vm._v(_vm._s(c.holder_name))]),
                        _c("td", [_vm._v(_vm._s(c.expiry_date))]),
                        _c("td", [_vm._v(_vm._s(c.gateway || "—"))]),
                        _c(
                          "td",
                          [
                            c.is_tokenized
                              ? _c(
                                  "vs-chip",
                                  {
                                    staticClass: "text-sm",
                                    attrs: {
                                      color: "success",
                                      transparent: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("user_credit_cards.yes"))
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("—"),
                                ]),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            c.is_default
                              ? _c(
                                  "vs-chip",
                                  {
                                    staticClass: "text-sm",
                                    attrs: {
                                      color: "primary",
                                      transparent: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("user_credit_cards.yes"))
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("—"),
                                ]),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "text-nowrap" },
                          [
                            !c.is_default
                              ? _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: "subscriptions.edit",
                                      expression: "'subscriptions.edit'",
                                    },
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top",
                                      value: _vm.$t(
                                        "user_credit_cards.set_default"
                                      ),
                                      expression:
                                        "$t('user_credit_cards.set_default')",
                                      modifiers: { top: true },
                                    },
                                  ],
                                  staticClass:
                                    "h-5 w-5 stroke-current text-primary cursor-pointer align-middle mr-1",
                                  attrs: { icon: "StarIcon" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setDefault(c)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: "subscriptions.delete",
                                  expression: "'subscriptions.delete'",
                                },
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top",
                                  value: _vm.$t("action.delete"),
                                  expression: "$t('action.delete')",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass:
                                "h-5 w-5 stroke-current text-danger cursor-pointer align-middle",
                              attrs: { icon: "Trash2Icon" },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmRemove(c)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }